export const STATUS_ORDER = [
    'classification',
    'new',
    'in_progress',
    'waiting_response',
    'reopened',
    'resolved',
    'closed',
    'rejected',
]


export const statusPriority = Object.fromEntries(
    STATUS_ORDER.map((slug, index) => [slug, index])
)
